// Copyright (c) 2012-2021 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved. NOTICE: All information contained herein
// is, and remains the property of GRAB. The intellectual and technical concepts contained herein are confidential, proprietary
// and controlled by GRAB and may be covered by patents, patents in process, and are protected by trade secret or copyright law.
//
// You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate, adapt or change this material
// in any way unless prior written permission is obtained from GRAB. Access to the source code contained herein is hereby
// forbidden to anyone except current GRAB employees or contractors with binding Confidentiality and Non-disclosure agreements
// explicitly covering such access.
//
// The copyright notice above does not evidence any actual or intended publication or disclosure of this source code,
// which includes information that is confidential and/or proprietary, and is a trade secret, of GRAB.
//
// ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR THROUGH USE OF THIS SOURCE
// CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE LAWS AND
// INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY
// OR IMPLY ANY RIGHTS TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING
// THAT IT MAY DESCRIBE, IN WHOLE OR IN PART.

import { fetchDeviceTrace } from '../api/devices'
import moment, { Moment } from 'moment'
import { message } from 'antd'
import { groupTracks } from 'utils/groupTracks'
import { chunkify } from 'utils/array'
interface IGPSTraceState {
  deviceId?: number
  isTraceEnable: boolean
  isGPSTrackerVisible: boolean
  currentTrace: []
  traceTime: Moment[]
}

const INTERVAL_SIZE = 5

export const gpsTrace = {
  state: {
    deviceId: undefined,
    traceTime: [],
    isTraceEnable: false,
    isGPSTrackerVisible: false,
    currentTrace: []
  } as IGPSTraceState,
  reducers: {
    updateState: (state, payload) => ({ ...state, ...payload }),
    updateTraceTime: (state, traceTime) => ({ ...state, traceTime }),
    clear () {
      return {
        deviceId: undefined,
        traceTime: [],
        isTraceEnable: false,
        isGPSTrackerVisible: false,
        currentTrace: []
      }
    }
  },
  effects: dispatch => ({
    async setActiveDevice (deviceId) {
      this.updateState({
        deviceId
      })
    },
    async setGPSTrackerVisible (isGPSTrackerVisible) {
      this.updateState({ isGPSTrackerVisible })
      if (!isGPSTrackerVisible) {
        this.updateState({ deviceId: undefined, currentTrace: undefined })
      }
    },
    async fetchAndUpdateDeviceTrace (_, state) {
      const now = new Date()
      const { deviceId, traceTime } = state.gpsTrace
      if (!deviceId) {
        return this.updateState({
          currentTrace: []
        })
      }
      try {
        const [startDate, endDate] = traceTime;
        const interval = endDate.diff(startDate, 'days')
        const chunks: number[] = chunkify(interval, INTERVAL_SIZE)

        let allTraces = []
        let tracePromises = []
        for (let i = 0; i < chunks.length; i++) {
          const daysAgoStart = chunks.slice(i).reduce((acc, x) => x + acc)

          // const startTime = moment(now).subtract(daysAgoStart, 'day')
          // const endTime = moment(now).subtract(daysAgoStart - chunks[i], 'day')
          const startTime = startDate.clone().add(INTERVAL_SIZE * i, 'day')
          let endTime;
          if (i === chunks.length - 1) {
            endTime = endDate.clone()
          } else {
            endTime = startDate.clone().add(INTERVAL_SIZE * (i + 1), 'day')
          }
          tracePromises.push(
            fetchDeviceTrace({
              deviceId,
              startTime: startTime.format('YYYY-MM-DD HH:mm:ss'),
              endTime: endTime.format('YYYY-MM-DD HH:mm:ss')
            })
          )
        }

        const traces = await Promise.all(tracePromises)
        traces.forEach(({ trace }) => {
          trace = trace || []
          allTraces = [...allTraces, ...trace]
        })

        this.updateState({
          currentTrace: groupTracks(allTraces)
        })
        if (!allTraces.length) {
          message.info('No trace records')
        }
      } catch (e) {
        message.info('Fetch trace data failed')
        console.log(e.message)
        console.log(e)
      }
    }
  })
}
